module.exports = __webpack_public_path__ + "static/img/1_0012.b54ebf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0012.jpg
// module id = FAjU
// module chunks = 0